module.exports = __webpack_public_path__ + "img/ts18.a01a81e7.png";